import { useState } from 'react';
import { getTableColumnData } from 'src/components/collapsible-table/table-column-prep';
import { makeDataForTable } from 'src/components/collapsible-table/table-data-prep';
import { IFilterObj, IGridMetrics } from 'src/components/filters';
import { useAppDispatch } from 'src/hooks';
import { setTableMetaData } from '../../../common/features/table/store/table-slice';
import { TableComponent } from '../../../pricing-simulator/types/generic-table.model';
import { getOpportunitySummaryTableDataV2 } from '../../store/planner-slice-async-thunks';

export default function useOpportunitySummary() {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const appDispatch = useAppDispatch();
  const getAndSetOpportunitySummaryTableRows = (args: {
    filters: IFilterObj[];
    toggle: string;
    localFilters: IGridMetrics;
    sourceId: number;
    moduleId: number;
    scenarioId: number;
  }) =>
    appDispatch(getOpportunitySummaryTableDataV2(args)).then((tableResData) => {
      const { inputCols, tableData } = tableResData.payload as any;
      appDispatch(setTableMetaData({ tableData }));
      setColumns([
        ...getTableColumnData(
          inputCols,
          TableComponent.PLANNER,
          tableData.header,
          [],
          false
        )
      ]);
      setRows(makeDataForTable(tableData.row));
    });

  return {
    getAndSetOpportunitySummaryTableRows,
    columns,
    rows
  };
}
